import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 6766F53D-88E4-452A-A222-7F50DDFB757C
 * name near-me
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/near-me.svg
 * tags
 */
export const NearMeIcon = createSvgIcon(<><path d="M21,3L3,10.53V11.5L9.84,14.16L12.5,21H13.46L21,3Z" /></>, 'NearMeIcon');
export default NearMeIcon